// src/services/macroMarketService.ts
// Service macro marché : dominance BTC/ETH servie par le backend EcotoneAI
// (endpoint canonique /api/market/metrics) — aucun appel direct à CoinGecko.

export interface MacroMarketData {
  btcDominance: number;
  ethDominance: number;
  lastUpdated: number;
}

let cache: MacroMarketData | null = null;
const TTL = 1800000; // 30 minutes en ms

export async function getMacroMarketData(): Promise<MacroMarketData | null> {
  const now = Date.now();
  if (cache && now - cache.lastUpdated < TTL) {
    return cache;
  }
  try {
    const res = await fetch('/api/market/metrics');
    if (!res.ok) throw new Error('API marché indisponible');
    const json = await res.json();
    const btcDominance = Number(json.btcDominance);
    const ethDominance = Number(json.ethDominance);
    if (!Number.isFinite(btcDominance) || !Number.isFinite(ethDominance)) {
      return cache || null;
    }
    const lastUpdated = json.lastUpdate ? new Date(json.lastUpdate).getTime() : now;
    cache = {
      btcDominance,
      ethDominance,
      lastUpdated,
    };
    return cache;
  } catch (error) {
    // Fallback : retourne dernière valeur si dispo
    return cache || null;
  }
}
